export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/getup_stats-aa2bc6750f3e77cdb810c6c9bee354af.png";